var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.3327 38.3134V40.0001C58.3304 43.9535 57.0503 47.8003 54.6831 50.9668C52.316 54.1332 48.9887 56.4496 45.1975 57.5706C41.4063 58.6915 37.3543 58.5569 33.6459 57.1868C29.9374 55.8167 26.7712 53.2846 24.6194 49.968C22.4677 46.6515 21.4456 42.7282 21.7058 38.7833C21.9659 34.8384 23.4942 31.0833 26.0629 28.078C28.6315 25.0727 32.1028 22.9783 35.959 22.107C39.8153 21.2357 43.8498 21.6344 47.461 23.2434",
    stroke: "#181818",
    strokeWidth: 1.25,
    strokeMiterlimit: 2.61313,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3333 25.334L40 43.6857L34.5 38.1857",
    stroke: "#181818",
    strokeWidth: 1.25,
    strokeMiterlimit: 2.61313,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66 37.6229V40.0149C65.9968 45.6216 64.1813 51.077 60.8243 55.5676C57.4672 60.0582 52.7485 63.3433 47.3719 64.933C41.9953 66.5227 36.2489 66.3318 30.9896 64.3888C25.7304 62.4458 21.2401 58.8547 18.1885 54.1512C15.1369 49.4478 13.6875 43.8838 14.0564 38.2893C14.4253 32.6947 16.5927 27.3693 20.2355 23.1073C23.8783 18.8452 28.8012 15.8749 34.2701 14.6393C39.7389 13.4036 45.4607 13.969 50.582 16.2509",
    stroke: "#181818",
    strokeWidth: 1.25,
    strokeMiterlimit: 2.61313,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.99fe3827c7d0ca419b40f5c94acaec6b.svg";
export { ForwardRef as ReactComponent };